<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Fonte Dei Dati" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <span v-if="isReadOnly">{{ jsonDataFonteDati.voce }}</span>
                            <b-form-textarea v-else v-model="jsonDataFonteDati.voce" :readonly="isReadOnly" max-rows="10" rows="8"> </b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataFonteDati: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataFonteDati: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaFonteDati: "/rsaschedarelazionesanitariafontedati",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaFonteDati() {
            let me = this;
            console.log("Prova accettazione in fonte", me.idAccettazione);
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaFonteDati + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaFonteDatiSuccess, me.resultResponseSchedaRelazioneSanitariaFonteDatiError);
        },

        resultResponseSchedaRelazioneSanitariaFonteDatiSuccess(response) {
            let me = this;
            me.jsonDataFonteDati = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaFonteDatiError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataFonteDati = {
                id: null,
                idAccettazione: me.idAccettazione,
                voce: null,
            };
        },

        onFonteDati() {
            let me = this;
            me.jsonDataFonteDati.idAccettazione = me.idAccettazione;
            console.log("Prova accettazione in fonte1", me.idAccettazione);
            if (!me.jsonDataFonteDati.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaFonteDati, me.jsonDataFonteDati, me.saveSchedaRelazioneSanitariaFonteDatiSuccessResponse, me.saveSchedaRelazioneSanitariaFonteDatiErrorResponse);
        },
        saveSchedaRelazioneSanitariaFonteDatiSuccessResponse() {},
        saveSchedaRelazioneSanitariaFonteDatiErrorResponse() {
            console.error("Errore nel salvataggio fonte dei dati:");
        },
    },
};
</script>
